import { useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Sparkles, X } from "lucide-react";

const SafarSamridhiBanner = () => {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ y: 100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: 100, opacity: 0 }}
        transition={{ delay: 2, duration: 0.5 }}
        className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-4 sm:w-80 z-50"
        data-testid="safar-banner"
      >
        <div className="bg-gradient-to-r from-amber-700 to-yellow-700 rounded-xl shadow-2xl p-4 relative border border-amber-500/30">
          <button
            onClick={() => setDismissed(true)}
            className="absolute top-2 right-2 text-amber-200 hover:text-white"
            data-testid="dismiss-banner"
          >
            <X size={16} />
          </button>
          <div className="flex items-start gap-3">
            <div className="w-10 h-10 bg-amber-500/30 rounded-lg flex items-center justify-center flex-shrink-0">
              <Sparkles className="h-5 w-5 text-amber-200" />
            </div>
            <div>
              <p className="text-white font-semibold text-sm leading-tight">Safar Samridhi</p>
              <p className="text-amber-100/80 text-xs mt-0.5 mb-2">Save monthly, earn up to 15% bonus. Travel in prosperity!</p>
              <Link to="/safar-samridhi" onClick={() => setDismissed(true)}>
                <span className="inline-flex items-center gap-1 text-xs font-semibold bg-white text-amber-800 px-3 py-1.5 rounded-full hover:bg-amber-50 transition-colors">
                  Learn More
                </span>
              </Link>
            </div>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export default SafarSamridhiBanner;
